<script lang="ts">
  import ClassListPage from '$lib/components/classes/ClassListPage.svelte';
  import type { PageProps } from './$types';
  let { data }: PageProps = $props();
</script>

<main class="container py-3" id="main-content">
  <ClassListPage currentClassesPromise={data.currentClassesPromise} />
</main>

